import React from "react";

const Logo = () => {
  return (
    <div className="logo">
      {/* Utilisez la balise <video> pour intégrer votre vidéo */}
      <video width="440" height="240" autoPlay muted>
        <source src="./BanniereGentleDrinker.mp4" type="video/mp4" />
        Votre navigateur ne prend pas en charge la balise vidéo.
      </video>
    </div>
  );
};

export default Logo;
